module.exports = __webpack_public_path__ + "welcome.png?a5e2ced8e4cc6dab1a4d2b399ee791f0";


//////////////////
// WEBPACK FOOTER
// ./static/assets/welcome.png
// module id = 179
// module chunks = 0